<script>
import { mapActions, mapGetters, mapState } from "vuex";

import Scheduler from "./Components/Scheduler/Index";
import Confirmation from "./Components/Scheduler/Confirmation/Index";

export default {
  components: {
    Scheduler,
    Confirmation
  },

  methods: {
    ...mapActions("addresses", ["getAddresses"]),
    ...mapActions("allowProfessionalChangePreference", [
      "getConfigurableField",
      "getConfigurableFieldOptions"
    ]),
    ...mapActions("requireProductsPreference", [
      "getProductsConfigurableField",
      "getProductsConfigurableFieldOptions"
    ]),
    ...mapActions("orderScheduler", ["resetState"])
  },

  computed: {
    ...mapGetters("orderScheduler", ["canGoToCheckout"]),
    ...mapState("orderScheduler", ["orderConfirmed"])
  },

  async mounted() {
    await this.getAddresses();
    await this.getConfigurableField();
    await this.getConfigurableFieldOptions();
    await this.getProductsConfigurableField();
    await this.getProductsConfigurableFieldOptions();
  },

  beforeDestroy() {
    this.resetState();
  }
};
</script>

<template>
  <div class="container">
    <Scheduler v-if="!orderConfirmed" />

    <Confirmation v-if="orderConfirmed" />
  </div>
</template>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Index.vue